<template>
  <div class="container">
    <div class="weui-navbar daojia-navbar">
        <div class="daojia-navbar-left"><span class="icon-chevron-left" @click="goback()"></span></div>
        <h1 class="daojia-navbar-middle daojia-navbar-middle_logo"><a href="#"><img src="../../assets/img/misc/logo.svg"></a></h1>
        <div class="daojia-navbar-right">
        </div>
    </div>
    
    <div class="search-top">
      <div class="weui-search-bar weui-search-bar_focusing" id="searchBar">
          <form class="weui-search-bar__form">
              <div class="weui-search-bar__box">
                  <i class="weui-icon-search"></i>
                  <input type="search" class="weui-search-bar__input" id="searchInput" placeholder="搜索服务" v-model="term" ref="searchBar" required/>
                  <a href="javascript:" class="weui-icon-clear" id="searchClear" @click="term='';setFocus()"></a>
              </div>
              <label class="weui-search-bar__label" id="searchText">
                  <i class="weui-icon-search"></i>
                  <span>搜索</span>
              </label>
          </form>
      </div>
    </div>


    <div class="initializing" v-show="isLoading">
      <img src="../../assets/img/misc/loading.svg">
      <div>正在加载中..</div>
    </div>
    <div class="main" v-show="!isLoading">
      <div class="search" v-show="term.length>0">
        <div class="misc-item">
          <div class="item-box" >
            <div class="item" v-for="(item, index) in searchResults"  @click="goto('/misc/detail?id='+item.id)">
              <div>
                <img :src='item.icon'>
              </div>
              <div>{{item.name}}</div>
            </div>
          </div>
          <div class="no-result" v-if="searchResults.length<1">
            <img src="../../assets/img/misc/empty.svg" class="decoration"><br>
            没有找到符合的结果<br>请尝试其他关键词
            <br><br>
          </div>
          <div class="text-center">
            <span class="check-detail" @click="term=''">返回查看所有服务</span>
          </div>
        </div>
      </div>
      <div class="listing" v-show="term.length<1" >
        <div class="misc-menu">
          <template v-for="(item, index) in category" >
            <div class="tab" :class="{ active: index==activeCat }" @click="activeCat=index">
              <div :class="{ active: index==activeCat }">{{item.name}}</div>
            </div>
          </template>
          <div class="tab" :class="{ active: activeCat==911 }" @click="activeCat=911">
            <div :class="{ active: activeCat==911 }">商务合作</div>
          </div>
        </div>
        <div class="misc-item">
          <div class="promise">
            <div><span class="icon-check-circle color-orange"></span> 当天上门</div>
            <div><span class="icon-check-circle color-orange"></span> 专业师傅</div>
            <div><span class="icon-check-circle color-orange"></span> 合理报价</div>
          </div>

          <div class="item-box" v-for="(item, index) in category" v-show="activeCat==index">
            <div class="item" v-for="(cell, num) in item.children" @click="goto('/misc/detail?id='+cell.id)">
              <div>
                <img :src='cell.icon'>
              </div>
              <div>{{cell.name}}</div>
            </div>
          </div>

          <div v-show="activeCat==911" class="text-center">
            <br><br>
            <img src="../../assets/img/misc/contact.svg" class="decoration">
            <br>
          商务合作 / 团队加盟 / 开发新业务 <br>
          请电话联系 <a href="tel:0472738703" class="color-orange">0472 738 703
</a>
          <br><br>
          <a href="tel:0472738703" class="weui-btn weui-btn_default contact-btn"  ><span class="icon-phone"></span> 点击立即联系</a>
          </div>

        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'

export default {
  name: 'miscIndex',
  data () {
    return {
      isLeaving:false,
      isLoading:false,
      term:"",
      order:{},
      activeCat:0,
      category: {},
      options:{keys: ["service_name"],threshold:0.3},
      searchResults:"",
      searchRaw:[],
    }
  },
  methods: {
    goback(){
      if(this.term.length>0){
        this.term = "";
      }
      else{
        this.$router.push('/');
      }
    },
    getSearch: function(){
        this.$search(this.term, this.searchRaw, this.options).then(results => {
        this.searchResults = results;
        })
    },
    getUniqueListBy: function(arr, key) {
        return [...new Map(arr.map(item => [item[key], item])).values()]
    },
    setFocus: function(){
      this.$refs.searchBar.focus();
    },
  },
  computed: {

  },
  components: {
  },
  created: function () {
      let that = this;
      this.isLoading = true;
      
      this.axios.get(this.apiURL()+'/Globals/service_category')
        .then(function (response) {
          that.category = response.data.data;
          let raw = [];

          that.category.forEach(function (item, index) {
            raw = raw.concat(item.children);
            raw = that.getUniqueListBy(raw, 'id');
          });

          that.searchRaw = raw;

          if(that.$route.query.id){
            that.activeCat = that.category.findIndex(cate => cate.id === that.$route.query.id)
          }

          that.sleep(500).then(() => {
            that.isLoading = false;
          });
        })
        .catch(function (error) {
          alert("服务加载失败，请检查网络并重新尝试")
          console.log(error);
        });
    if (localStorage.order) {
    }
    else{
      //this.$router.push('/');
    }
  },
  watch: {
    term: function () {
      this.getSearch();
    },
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.container{
  padding-top:50px;
}

.listing{
  height:100%;
}

.search{
  padding-top:20px;
}
.main {
  overflow: hidden;
  position:fixed;
  top:93px;
  bottom:0;
  left:0;
  right:0;
}
.promo{
  img{
    max-width:100%;
    box-sizing:border-box;
    margin-top:10px;
  }
}
.misc-menu {
    color:#595D68;
    float:left;
    overflow:auto;
    width:22%;
    height:100%;
    box-sizing: border-box;
    padding-bottom: 40vh;
    background-color:#F4F5F8;
    .tab{
      text-align:center;
      padding:16px 0;
      font-size:0.9em;
      div{
        &.active{
          border-left:2px solid $color-orange;
          padding-left:0;
        }
        padding:2px 2px 2px 2px;
      }
      &.active{
        color:$color-orange;
        background-color:#fff;
        font-weight:bold;
      }
    }
  }

.misc-item {
  float:left;
  overflow:auto;
  width:78%;
  height: 100%;
  padding:0 3vw;
  box-sizing:border-box;
  padding-bottom: 60vh;
  img{
    width:20vw;
    height:20vw;
    border-radius:3px;
  }
  .head{
    margin-top:14px;
  }
  .item-box {
     width: 100%;
     display: flex;
     flex-flow: row wrap;
     align-content: flex-start;
     justify-content:start;
     .item {
        box-sizing: border-box;
        background-color: white;
        flex: 0 0 33%;
        text-align:center;
        font-size:0.8em;
        margin: 10px 0;
     }
  }
}

.search .misc-item{
  width:100%;
}

.daojia-navbar {
    position: fixed;
    background: rgba(255, 255, 255, 0.95);
    padding: 8px 10px;
    box-sizing: border-box;
    height: 50px;
}

.daojia-navbar-left {
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: left;
    span{
      font-size: 2em;
      color: #666;
    }
}

.daojia-navbar-middle_logo img{
    height:28px;
    padding-top:2px;
}

.daojia-navbar-middle {
    display: block;
    -webkit-box-flex: 2;
    -webkit-flex: 2;
    flex: 2;
    font-smoothing: antialiased;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    font-family: sans-serif;
    font-size: 1.2em;
    line-height: 1.3;
    font-weight: bold;
}

.daojia-navbar-right {
    font-size: 14px;
    line-height: 26px;
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: right;
}

.search-top{
    overflow: hidden;
    position: fixed;
    top: 49px;
    height:44px;
    bottom: 0;
    left: 0;
    right: 0;
    z-index:9999;
    width:100%;
}

.promise{
  font-size:0.8em;
  display: flex;
  justify-content:space-around;
  padding:10px 0;
}

.initializing{
  text-align:center;
  padding-top:50px;
  img{
    width:30%;
  }
}

.check-detail{
  border: 2px solid #e3e3e3;
  padding: 8px 18px;
  margin-top: 14px;
  margin-left:auto;
  margin-right:auto;
  display: inline-block;
  border-radius: 50px;
    -webkit-animation-timing-function: ease-in-out;
    -webkit-animation-name: breathe;
    -webkit-animation-duration: 1000ms;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-direction: alternate;
}

.no-result{
  text-align:center;
  color:#888;
  img{
    width:100%;
    display:inline-block;
  }
}

.contact-btn{
  width:70%;
}

.decoration{
  width:40vw!important;
  height:40vw!important;
  dislay:block;
}
</style>



// WEBPACK FOOTER //
// src/pages/misc/index.vue